import React, { memo } from 'react';

import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import { Popup, UiButton } from '@shared/ui';

import { useVisualizationsImage } from './useVisualizationsImage';
import cls from './VisualizationsImage.module.css';
import { Icon } from '../../../../../../components/newUI/Icon/Icon';

interface VisualizationsImageProps {
    classes?: string;
    id: number;
}

export const VisualizationsImage = memo(({ classes, id }: VisualizationsImageProps) => {
    const { visualizationEntities, onDeleteImage, onOpenPopup, isShowPopup, onHidePopup } =
        useVisualizationsImage(id);

    const { t } = useTranslation();

    return (
        <>
            <Popup
                isOpen={isShowPopup}
                onHidePopup={onHidePopup}
                btnActionCb={onDeleteImage}
                type="delete"
                deleteButtonText={t('VisualizationsImage.return.popup.danger')}
                cancelButtonText={t('VisualizationsImage.return.popup.cancel')}
                popupContentClassName={cls.secondModal}
                contentText={t('VisualizationsImage.return.popup.text')}
            />
            <div className={classNames(cls.VisualizationsImage, [classes])}>
                <img
                    src={visualizationEntities[id].preview_url}
                    alt={visualizationEntities[id].preview_url}
                />
                <div className={classNames(cls.delete)}>
                    <UiButton
                        onClick={onOpenPopup}
                        variant="icon"
                        startIcon={<Icon iconName="deleteImage" />}
                    />
                </div>
            </div>
        </>
    );
});
